import { RootState } from "store/store";

export const enlargeSelector = (state: RootState) => state.enlarge;
